<template>
  <div class="zip">
    <label class="control-label">{{ title }} </label>
    <div>
      <input ref="fileupload" type="file" @change="handleFileUpload" />

      
      <a v-if="value && isLink" target="_blank" :href="value">{{
        "download" | setText("Скачать")
      }}</a>
    </div>
    <br />
    <div>
      <fg-input
        class="hidden"
        :type="`text`"
        :value="result"
        :readonly="true"
      ></fg-input>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    tempUpload: false,
    newData: null,
    oldData: null,
  }),
  watch: {
    lastUpdate(val) {
      if (val) {
        this.tempUpload = false;
        this.$refs.fileupload.value = null;
      }
    },
  },
  computed: {
    ...mapState(["lastUpdate"]),
    isLink() {
      try {
        const urlObject = new URL(this.value);
        return true;
      } catch (error) {
        return false;
      }
    },
  },
  props: {
    title: {
      default: "Выберите файл",
    },
    titleKey: {
      default: "select_file",
    },
    value: {
      default: null,
    },
    result: {
      default: null,
    },
  },
  created() {
    this.oldData = this.value;
  },
  methods: {
    clear() {
      this.tempUpload = false;
      this.$refs.fileupload.value = null;
      this.$emit("input", null);
    },
    async handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        const reader = new FileReader();
        this.tempUpload = true;
        reader.readAsDataURL(file);
        await reader.addEventListener("load", () => {
          this.newData = reader.result;
        });
        this.$emit("input", event.target.files[0]);
      }
    },
  },
};
</script>

<style lang="scss">
.zip {
  background: #f2f2f2;
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 15px 15px 0;
}
.hidden {
  opacity: 0;
  height: 0;
}
</style>
